import { LEASE_SIGNING_FLOW } from 'lease-signing-flow-v2/store/key';
import { getApiActionTypes } from 'store/redux/redux_utils';

const FETCH_LEASE_DEPOSIT_TYPES = 'FETCH_LEASE_DEPOSIT_TYPES';

const actions = {
  ...getApiActionTypes(FETCH_LEASE_DEPOSIT_TYPES),
};

export const LEASE_SIGNING_FLOW_DEPOSIT_REDUCER = 'deposit';

const initialState = {
  depositType: {
    options: [],
    selected: null,
  },
};

const reducer = (state = initialState, action: any = {}) => {
  switch (action.type) {
    case actions[`${FETCH_LEASE_DEPOSIT_TYPES}_SUCCESS`]:
      return {
        ...state,
        depositType: {
          options: [...action.result.options],
          selected: action.result.selectedDepositType,
        },
      };
    default:
      return state;
  }
};

export default reducer;

export const selectSelectedLeaseDepositType = (state: any) =>
  state[LEASE_SIGNING_FLOW][LEASE_SIGNING_FLOW_DEPOSIT_REDUCER].depositType
    .selected;
